import { Plus, X } from "lucide-react";
import { useApp } from "@/lib/i18n";
import { AutoText, IconBtn } from "./Field";

const ROMAN = ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"];

const ItemRow = ({ no, it, onChange, onRemove, canWrite, testId }) => {
  const { L } = useApp();
  return (
    <div className="group grid grid-cols-[2.75rem_1fr_8.5rem_1.75rem] items-start gap-2 py-1.5" data-testid={testId}>
      <span className="pt-1">{no}</span>
      <div>
        {(it.heading || canWrite) && <AutoText value={it.heading || ""} bold disabled={!canWrite} onChange={(v) => onChange({ ...it, heading: v })} placeholder={canWrite ? L("Subtajuk (pilihan)", "Sub-heading (optional)") : ""} className={`text-sm ${it.heading ? "" : "h-0 py-0 opacity-0 focus:h-auto focus:py-0.5 focus:opacity-100 group-hover:h-auto group-hover:py-0.5 group-hover:opacity-100"}`} testId={`${testId}-heading`} />}
        <AutoText value={it.text} disabled={!canWrite} onChange={(v) => onChange({ ...it, text: v })} className="text-justify" testId={`${testId}-text`} />
        {(it.points || []).map((pt, k) => (
          <div key={k} className="ml-4 flex items-start gap-2 font-bold"><span className="pt-1">{ROMAN[k % 10]}.</span><AutoText value={pt} bold disabled={!canWrite} onChange={(v) => onChange({ ...it, points: it.points.map((x, j) => (j === k ? v : x)) })} testId={`${testId}-point-${k}`} /></div>
        ))}
      </div>
      <div className="text-right text-xs font-bold">
        <span className="block text-[10px] font-semibold uppercase tracking-wider text-slate-400">{L("Tindakan", "Action")}</span>
        <AutoText value={it.action} disabled={!canWrite} onChange={(v) => onChange({ ...it, action: v })} className="text-right placeholder:font-normal placeholder:italic placeholder:text-slate-300" placeholder={canWrite ? L("Tindakan / Makluman", "Action / Info") : ""} testId={`${testId}-action`} />
      </div>
      {canWrite ? <IconBtn onClick={onRemove} label={L("Buang perkara", "Remove item")} testId={`${testId}-remove`}><X size={14} /></IconBtn> : <span />}
    </div>
  );
};

export const SectionsEditor = ({ sections = [], onChange, canWrite }) => {
  const { L } = useApp();
  const setSec = (i, v) => onChange(sections.map((s, j) => (j === i ? v : s)));
  return (
    <div className="space-y-6" data-testid="official-sections">
      {sections.map((s, i) => (
        <div key={i} data-testid={`official-section-${i}`}>
          <div className="grid grid-cols-[2.75rem_1fr_1.75rem] items-start gap-2 font-bold">
            <span className="pt-1">{i + 1}.0</span>
            <AutoText value={s.title} bold disabled={!canWrite} onChange={(v) => setSec(i, { ...s, title: v.toUpperCase() })} testId={`official-section-title-${i}`} />
            {canWrite && <IconBtn onClick={() => onChange(sections.filter((_, j) => j !== i))} label={L("Buang bahagian", "Remove section")} testId={`official-section-remove-${i}`}><X size={14} /></IconBtn>}
          </div>
          {s.items.map((it, j) => (
            <ItemRow key={j} no={`${i + 1}.${j + 1}`} it={it} canWrite={canWrite} testId={`official-item-${i}-${j}`}
              onChange={(v) => setSec(i, { ...s, items: s.items.map((x, k) => (k === j ? v : x)) })} onRemove={() => setSec(i, { ...s, items: s.items.filter((_, k) => k !== j) })} />
          ))}
          {canWrite && <button onClick={() => setSec(i, { ...s, items: [...s.items, { heading: "", text: "", points: [], action: "" }] })} className="ml-12 flex items-center gap-1 text-xs font-semibold text-violet-700 hover:underline" data-testid={`official-item-add-${i}`}><Plus size={12} /> {L("Tambah perkara", "Add item")}</button>}
        </div>
      ))}
      {canWrite && <button onClick={() => onChange([...sections, { title: "HAL-HAL LAIN", items: [] }])} className="flex items-center gap-1 text-xs font-semibold text-violet-700 hover:underline" data-testid="official-section-add"><Plus size={12} /> {L("Tambah bahagian", "Add section")}</button>}
    </div>
  );
};
